import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Div } from '@fastnorth/kraken/components/layout';
import {
  splitTableHeaderCellVariants,
  splitTableHeaderLabelVariants,
  splitTableHeaderRowVariants,
} from './SplitTable.styles';

const SplitTableHeader = (): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });

  const headerLabel = (label: string): ReactElement => (
    <Div className={splitTableHeaderCellVariants()}>
      <span className={splitTableHeaderLabelVariants()}>{label}</span>
    </Div>
  );

  return (
    <Div className={splitTableHeaderRowVariants()} data-testid="split-table-header">
      {headerLabel(t('split_table_checkpoint'))}
      {headerLabel(t('split_table_passed_started'))}
      {headerLabel(t('split_table_first'))}
      {headerLabel(t('split_table_last'))}
    </Div>
  );
};

export default SplitTableHeader;
